"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePropsUsage = exports.getSpinnerKind = exports.getIconMarginPosition = exports.getFinalVariant = void 0;
var _ButtonOld = require("./Button.old.types");
var _Spinner = require("../../Spinner/Spinner.types");
var _logService = require("../../tools/service/log/logService");
var getSpinnerKind = exports.getSpinnerKind = function getSpinnerKind(variant) {
  var INVERSE_VARIANTS = ["".concat(_ButtonOld.Variant.DEFAULT), "".concat(_ButtonOld.Variant.SPECIAL), "".concat(_ButtonOld.Variant.DESTRUCTIVE), "".concat(_ButtonOld.Variant.QUIET_INVERSE), "".concat(_ButtonOld.Variant.PADDINGLESS_INVERSE)];
  var CRITICAL_VARIANTS = ["".concat(_ButtonOld.Variant.QUIET_DESTRUCTIVE), "".concat(_ButtonOld.Variant.PADDINGLESS_DESTRUCTIVE), "".concat(_ButtonOld.Variant.DESTRUCTIVE_PADDINGLESS) // TODO: To be removed, keep to avoid breaking change
  ];
  if (INVERSE_VARIANTS.includes(variant)) return _Spinner.Kind.INVERSE;
  if (CRITICAL_VARIANTS.includes(variant)) return _Spinner.Kind.CRITICAL;
  return _Spinner.Kind.DEFAULT;
};
var getFinalVariant = exports.getFinalVariant = function getFinalVariant(variant) {
  var VARIANTS = Object.values(_ButtonOld.Variant);
  return !VARIANTS.includes(variant) ? _ButtonOld.Variant.DEFAULT : variant;
};
var getIconMarginPosition = exports.getIconMarginPosition = function getIconMarginPosition(_ref) {
  var chevron = _ref.chevron,
    dropdown = _ref.dropdown;
  return chevron || dropdown ? 'left' : 'right';
};
var validatePropsUsage = exports.validatePropsUsage = function validatePropsUsage(_ref2) {
  var chevron = _ref2.chevron,
    dropdown = _ref2.dropdown,
    icon = _ref2.icon,
    variant = _ref2.variant;
  if ((chevron || dropdown) && icon) {
    throw new Error("Invalid props. You can't use chevron or dropdown with icon props");
  }
  if (chevron && dropdown) {
    throw new Error("Invalid props. You can't use chevron and dropdown props together");
  }

  // TODO: Uncomment this after mergning chip changes
  // logSpecificErrorMessage(
  //   `OLD BUTTON`,
  //   'This component has been deprecated, you should import the Button from cozy-core/new/Button folder.',
  // );

  if (variant === _ButtonOld.Variant.SPECIAL) {
    (0, _logService.logSpecificErrorMessage)("BUTTON", 'The variant "special" is deprecated. Please check with a designer which variant will fit the screen interaction hierarchy');
  }
  if (variant === _ButtonOld.Variant.DESTRUCTIVE_PADDINGLESS) {
    (0, _logService.logSpecificErrorMessage)("BUTTON", 'The variant "destructivePaddingless" is deprecated. Use the "paddinglessDestructive" instead');
  }
};